module.exports = __webpack_public_path__ + "img/barcelo-room-5.76db88e6.jpg";